import * as React from 'react';
import Tab from '@material-ui/core/Tab';
import styles from './Notifications.module.scss';
import { translate, TranslatorProps } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';

import { ComponentWithInjectedProps } from 'utils/injectedProps';
import NotificationStore, { Subscription } from 'stores/NotificationStore';
import DashboardStore from 'stores/DashboardStore';
import ElectroResponseMessage from 'forms/components/inputs/ElectroResponseMessage';
import PageTitle from 'components/PageTitleLegacy/PageTitle';
import PageWrapper from 'components/PageWrapper/PageWrapper';
import { ElectroTabs, SearchTextField } from 'components/ExtendedUiElements/customized';

import SentRequests from './SentRequests';
import Notifications from './Notifications';
import ActionableNotifications from './ActionableNotifications';
import { ElectroURLTabs } from '../../components/ElectroURLTabs/ElectroURLTabs';

type InjectedProps = {
  notificationStore: NotificationStore,
  dashboardStore: DashboardStore,
} & TranslatorProps;

@translate()
@inject('notificationStore', 'dashboardStore')
@observer
export default class Container extends ComponentWithInjectedProps<{}, {}, InjectedProps> {
  @observable selectedTabIndex = 1;
  @observable searchInputValue = '';
  @observable currentSearch = '';
  @observable actionableNotificationsSubscription: ?Subscription;

  componentDidMount() {
    const { notificationStore } = this.props;

    this.actionableNotificationsSubscription = notificationStore.subscribeToNotifications(
      { type: 'actionable', urlParams: [], searchParams: [] },
      { background: false }
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.onTabChange(this.props.location.state?.tab || 0);
  }

  componentWillUnmount() {
    const { notificationStore } = this.props;

    if (this.actionableNotificationsSubscription) {
      notificationStore.unsubscribeFromNotifications(this.actionableNotificationsSubscription.id);
    }
  }

  handleSearchFormSubmit = (event: SyntheticInputEvent<HTMLFormElement>) => {
    event.preventDefault();

    setImmediate(() => {
      this.currentSearch = String(this.searchInputValue);
    });
  };

  handleSearchTextFieldChange = (event: ?SyntheticInputEvent<HTMLInputElement>) => {
    const newValue = event && event.target.value;

    if (!newValue) {
      this.searchInputValue = '';
    } else {
      this.searchInputValue = newValue;
    }
  };

  renderSearchBar() {
    const { t } = this.props;

    return (
      <form onSubmit={this.handleSearchFormSubmit}>
        <SearchTextField
          placeholder={t('general:placeholders.search')}
          value={this.searchInputValue}
          disabled={this.selectedTabIndex !== 1}
          onChange={this.handleSearchTextFieldChange}
          onClear={() => {
            this.currentSearch = '';
            this.handleSearchTextFieldChange();
          }}
        />
      </form>
    );
  }

  onTabChange(value) {
    this.selectedTabIndex = value;
    this.searchInputValue = '';
    this.currentSearch = '';
  }

  render() {
    const { t, notificationStore } = this.props;

    const actionableCount =
      this.actionableNotificationsSubscription &&
      this.actionableNotificationsSubscription.controller.pagination.total;

    return (
      <PageWrapper isFlex={false} isAuto={true}>
        <ElectroResponseMessage localState={notificationStore.localState} />

        <PageTitle title={t('general:notification_plural')} isCentred={true} />

        <ElectroURLTabs
          centered={true}
          defaultTab={1}
          style={{ paddingTop: 12 }}
          onChange={value => this.onTabChange(value)}
        >
          <Tab label={t('general:labels.sent_requests')} />
          <Tab label={t('general:notification_plural')} />
          <Tab
            label={`${t('general:labels.action_required')}${
              actionableCount ? ` (${actionableCount})` : ''
            }`}
          />
        </ElectroURLTabs>

        <div className={styles.notifications}>
          <ul>
            {this.selectedTabIndex === 0 && <SentRequests />}
            {this.selectedTabIndex === 1 && (
              <React.Fragment>
                {/*<p>{this.renderSearchBar()}</p>*/}
                <Notifications searchTerm={this.currentSearch} />
              </React.Fragment>
            )}
            {this.selectedTabIndex === 2 && <ActionableNotifications />}
          </ul>
        </div>
      </PageWrapper>
    );
  }
}
